import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import BreadcrumbSection from "components/BreadcrumbSection";
import ProductComponent from "components/ProductComponent";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import VendorSidebar from "inc/VendorSidebar";
import { useAuth } from "context/UserContext";
import { deleteProduct, fetchCategoryProducts } from "api/ProductService";
import { Sentry, Spinner } from "react-activity";
import CommonModal from "components/CommonModal";
const Products = () => {
  const { user } = useAuth();

  const [showFollowers, setShowFollowers] = useState(false);
  const navigate = useNavigate();

  return (
    <Col lg={12} xl={12}>
      <div className="profile_details_style mb-3 header_profile3">
        <h3>Products</h3>

        <Button
          onClick={() => navigate("/vendor/addproduct")}
          variant="info"
          className="border-radius-100 ms-2 px-4 hAnswers"
        >
          <Icon
            icon="material-symbols:add-rounded"
            fontSize={20}
            className="me-1"
          />
          Add Product
        </Button>
      </div>
      <div className="profile_details_style mb-3 header_profile2  d-flex  justify-content-between ">
        <div className="d-flex align-items-center">
      <Icon icon="mdi:arrow-left" style={{fontSize: "24px"}} className="me-4" onClick={() => navigate("/vendor/my-profile")}/>
      <h3 className="mb-0">Products</h3>
      </div>
        <Button
          onClick={() => navigate("/vendor/addproduct")}
          variant="info"
          className="border-radius-100 ms-2 px-4 hAnswers d-flex align-items-center"
        >
          <Icon
            icon="material-symbols:add-rounded"
            fontSize={20}
            className=""
          />
          <span className="header_profile1 ms-2">  Add Product</span>
        </Button>
      </div>

      <ProductComponent userId={user?._id} />
    </Col>
  );
};

export default Products;
